import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR };

export const VALIDATE_DAY = "VALIDATE_DAY";
export const FETCH_ACTIVE_DAY = "FETCH_ACTIVE_DAY";
export const UPDATE_ACTIVE_DAY = "UPDATE_ACTIVE_DAY";
export const VALIDATE_DAY_SEND_DATA_SUCCESS = "VALIDATE_DAY_SEND_DATA_SUCCESS";
export const CAN_VALIDATE_DAY = "CAN_VALIDATE_DAY";

export const SET_ALL_DAYS = "SET_ALL_DAYS";

export const SYNCHRO_GET_ACTIVE_DAY = "SYNCHRO_GET_ACTIVE_DAY";
